import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibraryListComponent } from './library-list.component';
import {MomentPipeModule} from '../../pipes/moment-pipe/moment-pipe.module';
import {IconsModule} from '../icons/icons.module';
import {PortalModule} from '@angular/cdk/portal';
import {CardModule} from '../card/card.module';



@NgModule({
  declarations: [LibraryListComponent],
  exports: [
    LibraryListComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    MomentPipeModule,
    IconsModule,
    PortalModule
  ]
})
export class LibraryListModule { }
